module.exports = __webpack_public_path__ + "static/media/bracket_d_iron.ff1eb906.webp";